import { Controller } from '@hotwired/stimulus';
const hibpApiPromise =
  process.env.NODE_ENV === 'test'
    ? import('../services/hibp_mock.js')
    : import('../services/hibp.js');

// Connects to data-controller="hibp"
export default class extends Controller {
  connect() {
    hibpApiPromise.then(
      (hibpCaller) => (this.sendApiRequest = hibpCaller.default),
    );
  }

  async check() {
    if (this.element.value.length < 8) {
      this.publishResult(false);
      return;
    }

    const hash = await this.sha1(this.element.value);
    const apiResponse = await this.sendApiRequest(hash.substring(0, 5));
    const pwned = this.isPwned(hash, apiResponse);

    this.publishResult(pwned);
  }

  isPwned(hash, apiResponse) {
    // apiResponse looks like this:
    //
    //   00971C2E2A1FDA9B1C4F31C503A2600EB98:1
    //   00A094D3CC4A50C67D67D29FEE6DD99F86E:10
    //   00C3A00E40FDF0B2CBABB665AA6208F6D77:5
    //
    // where the characters before the colon are the suffix of the hash in the dataset (i. e. the
    // hash without the first 5 characters). The number behind the colon is the number of times the
    // password appears in the hibp dataset.
    return apiResponse
      .split('\n')
      .map((line) => line.substring(0, 35))
      .some((suffix) => suffix == hash.slice(5).toUpperCase());
  }

  publishResult(pwned) {
    const event = new Event(`hibpCheck${pwned ? 'Pwned' : 'Good'}`, {
      bubbles: true,
    });
    this.element.dispatchEvent(event);
  }

  async sha1(string) {
    const hash = await crypto.subtle.digest(
      'SHA-1',
      new TextEncoder().encode(string),
    );
    const hashBytes = new Uint8Array(hash);

    let hashHex = '';
    hashBytes.forEach(
      (byte) => (hashHex += byte.toString(16).padStart(2, '0')),
    );

    return hashHex;
  }
}
